import React, { useEffect, useState } from "react";
import {
  Grid,
  makeStyles,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Button,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Typography,
  Divider, Card,
  FormLabel,
  OutlinedInput,
  Chip,
  CardContent,
} from "@material-ui/core";
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from "react-redux";
import {
  getCandidateReferredFrom,
  getSingleSignee,
  updateSignee,
  getCategories
} from "../../store/action";
import history from "../../utils/HistoryUtils";
import Notification from "../../components/Notification/Notification";
import UtilService from "../../helper/service";
import axios from "axios";
import apiConfigs from "../../config/config";
import { getStaffDetail, getCompilanceOfficerDetail } from "../../store/action/staff/staffAction";
import { getUmbrellDetail } from "../../store/action/umbrella/umbrellaAction";
import { useGooglePlaceAutoCompleteForCandidate } from "../../components/GoogleAPI/google_place_autocomplete";
import { useRef } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { customEnLocale } from "../../helper/customLocale";
import moment from "moment";
// import { Autocomplete } from "@material-ui/lab";
import Loading from "../../components/Loading/Loading";
import Autocomplete from '@material-ui/lab/Autocomplete';
import theme from "../../theme";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  customHeading: {
    color: theme.palette.grey[800]
  },
  radioGroup: {
    flexDirection: "row",
  },
  formControl: {
    width: "100%",
  },
  mainTitle: {
    fontSize: 18,
    color: theme.primary,
    fontWeight: "500",
  },
  footerBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "5px",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  cardBox: {
    background: "#cae0f7",
    padding: 12
  },
  dayGridItem: {
    flex: '1 0 auto',
    minWidth: '70px',
    // maxWidth: '100px',
    margin: '0 4px',
  },
  preferenceCard: {
    borderRadius: '12px',
    transition: 'all 0.2s ease',
    height: '100%',
    border: "1px solid grey",
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
  },
  cardContent: {
    padding: '8px !important',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.palette.background.main
  },
  dayTitle: {
    fontWeight: 600,
    marginBottom: '6px',
    textAlign: 'center',
  },
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  checkbox: {
    padding: '2px',
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  checkboxLabel: {
    margin: 0,
    marginBottom: '2px',
    '& .MuiFormControlLabel-label': {
      fontSize: '0.85rem',
    },
  },
}));

const UpdateSignee = ({ match }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const user_id = match.params.id;
  const [signeeNotify, setSigneeNotify] = useState(false);
  const {
    getCandidateReferrredForm,
    loading,
    getSingleSigneeItem,
    updateSigneeSuccess,
    updateSigneeError,
    getCategoriesItem
  } = useSelector((state) => state.signee);
  const disFutureDate = UtilService.disabledPastDate();
  const [bdate, setBdate] = useState(null);
  const [rdate, setRdate] = useState(null);
  const [staff, setStaff] = useState([]);
  const [umbrella, setUmbrella] = useState([]);
  const [specialitya, setSpeciality] = useState([]);
  const [compilanceOfficer, setCompilanceOfficer] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState([]);
  const [personName, setPersonName] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [preferences, setPreferences] = React.useState({});
  const [data, setData] = useState({
    password: "",
    mobile_number: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    date_of_birth: "",
    candidate_id: "",
    address_line_1: "",
    address_line_2: "",
    address_line_3: "",
    city: "",
    postcode: "",
    email: "",
    // candidate_referred_from:"",
    nationality: "",
    date_registered: "",
    organization_id: "",
    nmc_dmc_pin: "",
    gender: "",
    registration_status: "",
    payment_method: "",
    npm_revalidation_date: "",
    revalidation_due_date: "",
    apprisal_due_date: "",
    hrmc_engagement_reason: "",
    staff_id: "",
    name_of_bank: "",
    umbrella_id: "",
    account_number: "",
    sort_code: "",
    ni_number: "",
    speciality: [],
    monday_day: 0,
    monday_night: 0,
    tuesday_day: 0,
    tuesday_night: 0,
    wednesday_day: 0,
    wednesday_night: 0,
    thursday_day: 0,
    thursday_night: 0,
    friday_day: 0,
    friday_night: 0,
    saturday_day: 0,
    saturday_night: 0,
    sunday_day: 0,
    sunday_night: 0,
    is_travel: 0,
    no_of_shift: 0,
    name_of_kin: "",
    address_of_kin: "",
    contact_of_kin: "",
    econtact_of_kin: "",
    compilance_officer_id: "",
    categoryItem: []
  });

  const handleChange = (event) => {
    if (event.target.name === "is_travel") {
      setData({ ...data, [event.target.name]: parseInt(event.target.value) });
    } else {
      setData({ ...data, [event.target.name]: event.target.value });
    }
  };

  const handleAutoComplete = (event, newValue) => {
    setData((prev) => ({
      ...prev, categoryItem: newValue
    }));
    return;
  }

  const handleUmbrellaChange = (event) => {
    let umbrelaDetils = umbrella?.data.find((e) => e.id === event.target.value);
    if (umbrelaDetils != null && umbrelaDetils !== undefined) {
      data.umbrella_id = umbrelaDetils.id;
      data.name_of_bank = umbrelaDetils.bank_name;
      data.sort_code = umbrelaDetils.bank_sort_code;
      data.account_number = umbrelaDetils.bank_account_number;
    }
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const handleChangeCheckbox = (event) => {
    const isChecked = event.target.checked
    if (isChecked) {
      setData({ ...data, [event.target.name]: 1 });
    } else {
      setData({ ...data, [event.target.name]: 0 });
    }
  };

  const handleChangeDate = (event) => {
    let tempBdate = event.target.value;
    setData({ ...data, [event.target.name]: tempBdate });
    if (event.target.name === 'date_of_birth') {
      setBdate(tempBdate);
    }
    if (event.target.name === 'date_registered') {
      setRdate(tempBdate);
    }
  };
  const dateHandler = (name, date) => {
    setData({ ...data, [name]: date });
  }

  const getStaff = async () => {
    dispatch(
      getStaffDetail((result) => {
        if (result?.data) {
          setStaff(result);
        }
      })
    );
  };

  const getUmbrella = async () => {
    dispatch(
      getUmbrellDetail((result) => {
        if (result?.data) {
          setUmbrella(result);
        }
      })
    );
  };

  const getCompilanceOfficer = async () => {
    dispatch(
      getCompilanceOfficerDetail((result) => {
        if (result?.data) {
          setCompilanceOfficer(result);
        }
      })
    );
  };

  useEffect(() => {
    dispatch(getSingleSignee(user_id));
    setTimeout(() => {
      getSpecialities();
    }, 1000);
  }, [user_id]);

  useEffect(() => {
    // let categoriesStored = getSingleSigneeItem?.data?.categoryItem;
    // categoriesStored = JSON.parse(categoriesStored);

    // const DataObject = categories?.filter(item => categoriesStored.includes(item.id));
    // const formattedData = {
    //   ...getSingleSigneeItem.data,
    //   categoryItem: DataObject
    // }
    let categoriesStored = getSingleSigneeItem?.data?.categoryItem;
    let parsedCategories = []; // Initialize as an empty array for safety

    if (typeof categoriesStored === 'string' && categoriesStored.trim() !== '' && categoriesStored !== "undefined") {
      try {
        parsedCategories = JSON.parse(categoriesStored);
      } catch (error) {
        console.error("Error parsing categoryItem JSON:", error);
        console.error("Problematic JSON string:", categoriesStored);
      }
    }

    if (!Array.isArray(parsedCategories)) {
      parsedCategories = [];
    }

    const DataObject = categories?.filter(item => parsedCategories.includes(item.id));

    const formattedData = {
      ...getSingleSigneeItem.data,
      categoryItem: DataObject
    };

    if (getSingleSigneeItem?.data?.preferences) {
      setPreferences(getSingleSigneeItem.data.preferences);
    }

    setData(formattedData);
    setBdate(getSingleSigneeItem?.data?.date_of_birth?.split("-").reverse().join("-"));
    setRdate(getSingleSigneeItem?.data?.date_registered?.split("-").reverse().join("-"));
    setIsDataLoaded(true);
  }, [getSingleSigneeItem, categories]);


  const getSpecialities = async () => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    await axios
      .get(`${apiConfigs.API_URL}api/organization/get-specialities`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        setSpeciality(response?.data);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const signeeSubmitData = (e) => {
    const CategoryItemId = data?.categoryItem?.map(item => item.id);
    e.preventDefault();
    let requestData = {
      ...data,
      id: data.user_id,
      speciality: data.speciality.speciality_id,
      date_of_birth: data?.date_of_birth ? moment(data?.date_of_birth).format("YYYY-MM-DD") : "",
      npm_revalidation_date: data?.npm_revalidation_date ? moment(data?.npm_revalidation_date).format("YYYY-MM-DD") : "",
      revalidation_due_date: data?.revalidation_due_date ? moment(data?.revalidation_due_date).format("YYYY-MM-DD") : "",
      apprisal_due_date: data?.apprisal_due_date ? moment(data?.apprisal_due_date).format("YYYY-MM-DD") : "",
      date_registered: data?.date_registered ? moment(data?.date_registered).format("YYYY-MM-DD") : "",
      categoryItem: CategoryItemId
    };
    delete requestData.user_id;

    dispatch(updateSignee(requestData));
    setSigneeNotify(true);
  };

  const backPage = () => {
    history.goBack();
  };

  const handleChangeCheck = (event) => {
    const specialityData = JSON.parse(JSON.stringify(data));
    const isChecked = event.target.checked;
    if (isChecked) {
      specialityData?.speciality?.speciality_id.push(
        parseFloat(event.target.value)
      );
      setData(specialityData);
    } else {
      const newData = specialityData?.speciality?.speciality_id.filter(
        (item) => item !== parseFloat(event.target.value)
      );
      specialityData.speciality.speciality_id = newData;
      setData(specialityData);
    }
  };

  const address1Ref = useRef();
  const googleAutoCompleteSvc = useGooglePlaceAutoCompleteForCandidate();
  let autoComplete = "";

  const handleAddressSelect = async () => {
    let addressObj = await googleAutoCompleteSvc.getFullAddress(autoComplete);
    setData((prevData) => ({
      ...prevData,
      city: addressObj.locality,
      address_line_2: addressObj.address_line_2,
      postcode: addressObj.postcode,
      address_line_1: addressObj.address_line_1,
      latitude: addressObj.latitude,
      longitude: addressObj.longitude,
    }));
  };

  // const getCategories = async () => {
  //   const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
  //   await axios
  //     .get(`${apiConfigs.API_URL}api/organization/getActiveCategories`, {
  //       headers: {
  //         "content-type": "application/json",
  //         Authorization: `Bearer ${loggedInUser}`,
  //       },
  //     })
  //     .then((response) => {
  //       setCategories(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.error("error.message", error.message);
  //     });
  // };


  useEffect(() => {
    dispatch(getCategories());
  }, [])

  useEffect(() => {
    if (getCategoriesItem.length > 0) {
      setCategories(getCategoriesItem);
    }
  }, [getCategoriesItem])

  useEffect(() => {
    dispatch(getCandidateReferredFrom());
    getStaff();
    getCompilanceOfficer();
    getUmbrella();
    async function loadGoogleMaps() {
      // initialize the Google Place Autocomplete widget and bind it to an input element.
      // eslint-disable-next-line
      autoComplete = await googleAutoCompleteSvc.initAutoComplete(address1Ref.current, handleAddressSelect);
    }
    loadGoogleMaps();
    // setPersonName(defaultSelected);
  }, []);
  console.log(isDataLoaded)
  return (
    <>
      {(loading) && <Loading open={loading} />}

      {signeeNotify && updateSigneeSuccess?.message && (
        <Notification data={updateSigneeSuccess?.message} status="success" />
      )}

      <Paper className={classes.root} sx={{ p: 1 }}>
        <form onSubmit={(e) => signeeSubmitData(e)} autoComplete="off">
          <Grid container spacing={2}>

            {/* Personal Information Section */}
            <Grid item xs={12}>
              <Typography className={classes.customHeading}>
                Personal Information
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="first_name"
                label="First name"
                variant="outlined"
                name="first_name"
                value={data?.first_name || ""}
                helperText={updateSigneeError?.message?.first_name}
                error={!!updateSigneeError?.message?.first_name}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="last_name"
                label="Last name"
                variant="outlined"
                name="last_name"
                value={data?.last_name || ""}
                onChange={handleChange}
                helperText={updateSigneeError.message?.last_name}
                error={!!updateSigneeError.message?.last_name}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="email"
                label="Email"
                variant="outlined"
                name="email"
                value={data?.email || ""}
                onChange={handleChange}
                helperText={updateSigneeError.message?.email}
                error={!!updateSigneeError.message?.email}
                fullWidth
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="contact_number"
                label="Contact number"
                variant="outlined"
                name="contact_number"
                type="text"
                value={data?.contact_number || ""}
                // helperText={updateSigneeError.message?.contact_number}
                // error={!!updateSigneeError.message?.contact_number}
                onChange={handleChange}
                fullWidth
              // required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="date_of_birth"
                  value={data?.date_of_birth || null}
                  label="Date of birth"
                  name="date_of_birth"
                  variant="outlined"
                  onChange={(e) => dateHandler("date_of_birth", e)}
                  maxDate={new Date()}
                  style={{ width: "100%" }}
                  renderInput={props => <TextField
                    fullWidth
                    variant="outlined"
                    {...props}
                  />}
                  inputFormat="dd-MMM-yyyy"
                  fullWidth
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel>Gender </InputLabel>
                <Select value={data?.gender} name="gender" label="Gender" onChange={handleChange}>
                  <MenuItem value="Male" key="Male">Male</MenuItem>
                  <MenuItem value="Female" key="Female">Female</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Address Section */}
            <Grid item xs={12}>
              <Typography className={classes.customHeading}>
                Address Details
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="address_line_1"
                label="Address Line 1"
                variant="outlined"
                name="address_line_1"
                className="form-field"
                value={data?.address_line_1}
                inputRef={address1Ref}
                fullWidth
                onChange={handleChange}
                error={!!updateSigneeError.message?.address_line_1}
                helperText={updateSigneeError.message?.address_line_1}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="address_line_2"
                label="Address Line 2"
                variant="outlined"
                name="address_line_2"
                value={data?.address_line_2 || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="City"
                label="City"
                variant="outlined"
                name="city"
                value={data?.city || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="postcode"
                label="Postcode"
                variant="outlined"
                name="postcode"
                value={data?.postcode || ""}
                helperText={updateSigneeError.message?.postcode}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            {/* Registration Details Section */}
            <Grid item xs={12}>
              <Typography className={classes.customHeading}>
                Registration Details
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="nationality"
                label="Nationality"
                variant="outlined"
                name="nationality"
                value={data?.nationality || ""}
                onChange={handleChange}
                // helperText={updateSigneeError.message?.nationality}
                // error={!!updateSigneeError.message?.nationality}
                fullWidth
              // required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="date_registered"
                  label="Date Registered"
                  type="date"
                  name="date_registered"
                  variant="outlined"
                  value={data?.date_registered || null}
                  onChange={(e) => dateHandler("date_registered", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: "100%" }}
                  renderInput={props => <TextField
                    fullWidth
                    variant="outlined"  {...props} />}
                  inputFormat="dd-MMM-yyyy"
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="nmc_dmc_pin"
                label="Registered Body Pin"
                variant="outlined"
                name="nmc_dmc_pin"
                value={data?.nmc_dmc_pin || ""}
                onChange={handleChange}
                fullWidth
              // required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              {/* <FormControl
                variant="outlined"
                className={classes.formControl}
                required
                error={!!updateSigneeError.message?.staff_id ? true : false}
              >
                <InputLabel>Consultant</InputLabel>
                <Select
                  value={data?.staff_id}
                  label="Consultant"
                  name="staff_id"
                  required
                  onChange={handleChange}
                >
                  <MenuItem value="">Select Consultant</MenuItem>
                  {staff?.data != undefined &&
                    staff?.data &&
                    staff?.data.map((trustList, index) => {
                      return (
                        <MenuItem value={trustList.id} key={index}>
                          {trustList.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl> */}
              <Autocomplete
                options={staff?.data || []}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  staff?.data?.find((item) => item.id === data?.staff_id) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "staff_id",
                      value: newValue ? newValue.id : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Consultant"
                    variant="outlined"
                    required
                    error={!!updateSigneeError.message?.staff_id}
                    helperText={updateSigneeError.message?.staff_id || ""}
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="npm_revalidation_date"
                  label="SOE Registration Date"
                  type="date"
                  name="npm_revalidation_date"
                  variant="outlined"
                  value={data?.npm_revalidation_date || null}
                  onChange={(e) => dateHandler("npm_revalidation_date", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: "100%" }}
                  renderInput={props => <TextField variant="outlined" fullWidth  {...props} />}
                  inputFormat="dd-MMM-yyyy"
                  fullWidth
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="revalidation_due_date"
                  label="Revalidation Due Date"
                  type="date"
                  name="revalidation_due_date"
                  variant="outlined"
                  value={data?.revalidation_due_date || null}
                  onChange={(e) => dateHandler("revalidation_due_date", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: "100%" }}
                  renderInput={props => <TextField variant="outlined" fullWidth  {...props} />}
                  inputFormat="dd-MMM-yyyy"
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={customEnLocale}>
                <DatePicker
                  id="apprisal_due_date"
                  label="Appraisal Due Date"
                  name="apprisal_due_date"
                  variant="outlined"
                  value={data?.apprisal_due_date || null}
                  onChange={(e) => dateHandler("apprisal_due_date", e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  style={{ width: "100%" }}
                  renderInput={props => <TextField variant="outlined" fullWidth  {...props} />}
                  inputFormat="dd-MMM-yyyy"
                  firstDayOfWeek={1}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
              // required
              >
                <InputLabel>Registration Status </InputLabel>
                <Select
                  value={data?.registration_status}
                  name="registration_status"
                  label="Registration Status"
                  onChange={handleChange}
                >
                  <MenuItem value="No Restriction" key="No Restriction">
                    {" "}
                    No Restriction
                  </MenuItem>
                  <MenuItem value="Caution Order" key="Caution Order">
                    {" "}
                    Caution Order
                  </MenuItem>
                  <MenuItem value="Restricted" key="Restricted">
                    {" "}
                    Restricted
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              {/* <FormControl
                variant="outlined"
                className={classes.formControl}
              >
                <InputLabel>Compliance Officer</InputLabel>
                <Select
                  value={data?.compilance_officer_id}
                  label="Compliance Officer"
                  name="compilance_officer_id"
                  onChange={handleChange}
                >
                  <MenuItem value="">Select Compliance Officer</MenuItem>
                  {compilanceOfficer?.data &&
                    compilanceOfficer?.data.map((trustList, index) => {
                      return (
                        <MenuItem value={trustList.id} key={index}>
                          {trustList.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl> */}
              <Autocomplete
                options={compilanceOfficer?.data || []}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  compilanceOfficer?.data?.find(
                    (item) => item.id === data?.compilance_officer_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "compilance_officer_id",
                      value: newValue ? newValue.id : "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Compliance Officer"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>

            {/* Categories dropdown  */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}>

                <Stack>
                  <Autocomplete
                    multiple
                    id="tags-outlined"
                    name="categoryItem"
                    options={categories}
                    getOptionLabel={(option) => option.name}
                    // personName
                    value={data?.categoryItem}
                    onChange={handleAutoComplete}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Categories"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                      />
                    )}
                  />
                </Stack>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.customHeading}>
                Payroll Details
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box className="mt-3">
                <Typography>Payment Method</Typography>
                <RadioGroup name="payment_method"
                  value={data?.payment_method || ""}
                  onChange={handleChange}
                  className={classes.radioGroup}
                >
                  <FormControlLabel value="PAYE" control={<Radio />} label="PAYE" />
                  <FormControlLabel value="Umbrella" control={<Radio />} label="Umbrella" />
                </RadioGroup>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                error={!!updateSigneeError.message?.umbrella_id ? true : false}
              >
                <InputLabel>Umbrella Name</InputLabel>
                <Select
                  value={data?.umbrella_id}
                  label="Umbrella Name"
                  name="umbrella_id"
                  required={data?.payment_method === "Umbrella" ? true : false}
                  disabled={data?.payment_method === "PAYE" ? true : false}
                  onChange={handleUmbrellaChange}
                >
                  <MenuItem value="">Select Umbrella</MenuItem>
                  {umbrella?.data &&
                    umbrella?.data.map((trustList, index) => {
                      return (
                        <MenuItem value={trustList.id} key={index + "1"}>
                          {trustList.name_umbrella}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
              // required
              // error={!!updateSigneeError.message?.remark ? true : false}
              >
                <InputLabel>HRMC Engagement Reason </InputLabel>
                <Select
                  value={data?.hrmc_engagement_reason}
                  name="hrmc_engagement_reason"
                  label="HRMC Engagement Reason  Required"
                  onChange={handleChange}
                >
                  <MenuItem value="Self Employed" key="Self Employed">
                    {" "}
                    Self Employed
                  </MenuItem>
                  <MenuItem value="Partnership" key="Partnership">
                    {" "}
                    Partnership
                  </MenuItem>
                  <MenuItem
                    value="Limited Liability Partner"
                    key="Limited Liability Partner"
                  >
                    {" "}
                    Limited Liability Partner
                  </MenuItem>
                  <MenuItem
                    value="Ltd co inclu Personal Service"
                    key="Ltd co inclu Personal Service"
                  >
                    {" "}
                    Ltd co inclu Personal Service
                  </MenuItem>
                  <MenuItem value="Non-UK engagement" key="Non-UK engagement">
                    {" "}
                    Non-UK engagement
                  </MenuItem>
                  <MenuItem value="Another party PAYE" key="Another party PAYE">
                    {" "}
                    Another party PAYE
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="name_of_bank"
                label="Name of Bank"
                variant="outlined"
                name="name_of_bank"
                type="text"
                disabled={data?.payment_method === "Umbrella" ? true : false}
                value={data?.name_of_bank}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="account_number"
                label="Account Number"
                variant="outlined"
                name="account_number"
                type="text"
                value={data?.account_number}
                onChange={handleChange}
                disabled={data?.payment_method === "Umbrella" ? true : false}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="sort_code"
                label="Sort Code"
                variant="outlined"
                name="sort_code"
                type="text"
                value={data?.sort_code}
                onChange={handleChange}
                disabled={data?.payment_method === "Umbrella" ? true : false}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="ni_number"
                label="NI Number"
                variant="outlined"
                name="ni_number"
                type="text"
                value={data?.ni_number}
                fullWidth
                required
                error={!!updateSigneeError.message?.ni_number ? true : false}
                helperText={updateSigneeError.message?.ni_number}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.mainTitle}>
                Next of Kin
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="name_of_kin"
                label="Name"
                variant="outlined"
                name="name_of_kin"
                type="text"
                value={data?.name_of_kin}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="address_of_kin"
                label="Address"
                variant="outlined"
                name="address_of_kin"
                value={data?.address_of_kin || ""}
                type="text"
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="contact_of_kin"
                label="Contact Number"
                variant="outlined"
                name="contact_of_kin"
                value={data?.contact_of_kin || ""}
                type="text"
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="econtact_of_kin"
                label="Emergency Contact Number"
                variant="outlined"
                name="econtact_of_kin"
                type="text"
                value={data?.econtact_of_kin || ""}
                fullWidth
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl
                required
                error={updateSigneeError?.message?.speciality}
                component="fieldset"
                className={classes.formControl}
              >
                <FormLabel component="legend">Specialities</FormLabel>
                <Grid container>
                  {specialitya?.data != undefined &&
                    specialitya?.data &&
                    specialitya?.data.map((items, index) => {
                      return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={items.id}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color={theme.palette.listItem}
                                value={items.id}
                                checked={data?.speciality?.speciality_id.includes(
                                  items.id
                                )}
                                key={index}
                                onChange={handleChangeCheck}
                                name="speciality"
                              />
                            }
                            label={items.speciality_name}
                          />
                        </Grid>
                      );
                    })}
                </Grid>
                <FormHelperText>
                  {updateSigneeError?.message?.speciality
                    ? "The specialities field is required."
                    : ""}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.customHeading}>
                Preference
              </Typography>
            </Grid>

            <Grid container spacing={1} >


              {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(
                (day) => {
                  const dayKey = day.toLowerCase(); // e.g. "monday"
                  return (
                    <Grid item xs={12} sm={6} md={3} key={dayKey} className={classes.dayGridItem}>
                      <Card className={classes.preferenceCard} elevation={1}>
                        <CardContent className={classes.cardContent}>
                          <Typography variant="subtitle2" className={classes.dayTitle}>
                            {day}
                          </Typography>
                          <Box className={classes.checkboxGroup}>
                            <FormControl component="fieldset" className={classes.formControl}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={handleChangeCheckbox}
                                    checked={data?.[`${dayKey}_day`] === 1}
                                    name={`${dayKey}_day`}
                                    color={theme.palette.listItem}
                                  />
                                }
                                label="Day"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={handleChangeCheckbox}
                                    checked={data?.[`${dayKey}_night`] === 1}
                                    name={`${dayKey}_night`}
                                    color="primary"
                                  />
                                }
                                label="Night"
                              />
                            </FormControl>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                }
              )}

              {/* {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map((day) => {
                const dayKey = day.toLowerCase();
                return (
                  <Grid item xs={12} sm={6} md={3} key={dayKey} className={classes.dayGridItem}>
                    <Card className={classes.preferenceCard} elevation={1}>
                      <CardContent className={classes.cardContent}>
                        <Typography variant="subtitle2" className={classes.dayTitle}>
                          {day}
                        </Typography>
                        <Box className={classes.checkboxGroup}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleChangeCheckbox}
                                checked={preferences?.[`${dayKey}_day`] === 1}
                                name={`${dayKey}_day`}
                                color="primary"
                              />
                            }
                            label="Day"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={handleChangeCheckbox}
                                checked={preferences?.[`${dayKey}_night`] === 1}
                                name={`${dayKey}_night`}
                                color="primary"
                              />
                            }
                            label="Night"
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })} */}



              {/* <Grid item xs={12} sm={4} md={2} className={classes.dayGridItem}>
                <Card lassName={classes.preferenceCard}>
                  <CardContent className={classes.cardContent}>
                    <Typography variant="subtitle2" className={classes.dayTitle}>Monday</Typography>
                    <Box className={classes.checkboxGroup}>
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.monday_day === 1 ? true : false} name="monday_day" color="primary" />}
                        label="Day"
                      />
                       <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.monday_night === 1 ? true : false} name="monday_night" color="primary" />}
                        label="Night"
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4} md={2}>
                <Card className={classes.cardBox}>
                  <FormControl component="fieldset" className={classes.formControl}>
                    <p className="f-500"> Tuesday</p>
                    <div>
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.tuesday_day === 1 ? true : false} name="tuesday_day" color="primary" />}
                        label="Day"
                      />
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.tuesday_night === 1 ? true : false} name="tuesday_night" color="primary" />}
                        label="Night"
                      />
                    </div>
                  </FormControl>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4} md={2}>
                <Card className={classes.cardBox}>
                  <FormControl component="fieldset" className={classes.formControl}>
                    <p className="f-500"> Wednesday</p>
                    <div>
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.wednesday_day === 1 ? true : false} name="wednesday_day" color="primary" />}
                        label="Day"
                      />
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.wednesday_night === 1 ? true : false} name="wednesday_night" color="primary" />}
                        label="Night"
                      />
                    </div>
                  </FormControl>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4} md={2}>
                <Card className={classes.cardBox}>
                  <FormControl component="fieldset" className={classes.formControl}>
                    <p className="f-500">Thursday</p>
                    <div>
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.thursday_day === 1 ? true : false} name="thursday_day" color="primary" />}
                        label="Day"
                      />
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.thursday_night === 1 ? true : false} name="thursday_night" color="primary" />}
                        label="Night"
                      />
                    </div>
                  </FormControl>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4} md={2}>
                <Card className={classes.cardBox}>
                  <FormControl component="fieldset" className={classes.formControl}>
                    <p className="f-500">Friday</p>
                    <div>
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.friday_day === 1 ? true : false} name="friday_day" color="primary" />}
                        label="Day"
                      />
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.friday_night === 1 ? true : false} name="friday_night" color="primary" />}
                        label="Night"
                      />
                    </div>
                  </FormControl>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4} md={2}>
                <Card className={classes.cardBox}>
                  <FormControl component="fieldset" className={classes.formControl}>
                    <p className="f-500">Saturday</p>
                    <div>
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.saturday_day === 1 ? true : false} name="saturday_day" color="primary" />}
                        label="Day"
                      />
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.saturday_night === 1 ? true : false} name="saturday_night" color="primary" />}
                        label="Night"
                      />
                    </div>
                  </FormControl>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4} md={2}>
                <Card className={classes.cardBox}>
                  <FormControl component="fieldset" className={classes.formControl}>
                    <p className="f-500">Sunday</p>
                    <div>
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.sunday_day === 1 ? true : false} name="sunday_day" color="primary" />}
                        label="Day"
                      />
                      <FormControlLabel
                        control={<Checkbox onChange={handleChangeCheckbox} checked={data?.sunday_night === 1 ? true : false} name="sunday_night" color="primary" />}
                        label="Night"
                      />
                    </div>
                  </FormControl>
                </Card>
              </Grid> */}
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={6} sm={6}>
                <h3 className="f-900 mb-2 mt-12">How many shift are you looking to work per week?</h3>
                <p className="f-300">Select number of shifts per week.</p>
                <FormControl variant="outlined" style={{ width: "100%" }}>
                  {/* <InputLabel>Shift Type</InputLabel> */}
                  <Select
                    value={data?.no_of_shift || ""}
                    // label=""
                    name="no_of_shift"
                    onChange={handleChange}
                    className="w-100"
                  >
                    <MenuItem value="">
                      Select a shift
                    </MenuItem>
                    <MenuItem value="1">1 shift</MenuItem>
                    <MenuItem value="2">2 shift</MenuItem>
                    <MenuItem value="3">3 shift</MenuItem>
                    <MenuItem value="4">4 shift</MenuItem>
                    <MenuItem value="5">5 shift</MenuItem>
                    <MenuItem value="6">6 shift</MenuItem>
                    <MenuItem value="7">7 shift</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6} sm={6}>
                <FormControl component="fieldset">
                  <h3 className="f-900 mb-8 mt-24">Would you travel for work?</h3>
                  <RadioGroup name="is_travel" value={data?.is_travel} onChange={handleChange} className={classes.radioGroup}>
                    <FormControlLabel value={1} control={<Radio color="primary" />} label="Yes" />
                    <FormControlLabel value={0} control={<Radio color="primary" />} label="No" />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Box className={classes.footerBtn}>
            <Button color="primary" onClick={backPage}>Cancel</Button>
            <Button color="primary" variant="contained" type="submit" formNoValidate>Submit</Button>
          </Box>
        </form>
      </Paper >
    </>
  );
};

export default UpdateSignee;
